import ReturnBlock from "./FeatMapReturnBlock";
import {useState, useRef, useEffect, useContext} from "react";
import QueryGroup from "../_subcomponents/QueryGroup"
import {IBlock, IMapData} from "../../helpers/Interfaces"
import Button from "../../components/Button"
import {useParams, NavLink, useNavigate} from "react-router-dom";
import FeatMapTrgBlock from "./FeatMapTrgBlock";
import SourceCats from "./FeatMapSrcCats";
import AuthContext from "../../context/AuthContext";
import {Alert} from "@mui/material";
import FeatmapTools from "./FeatmapTools";
import BreadCrumbs from "../../components/BreadCrumbs";
import MapToolsBase, {LightTooltip} from "../_subcomponents/MapToolsBase"
import FeatUsemapTrgBlock from "./FeatUsemapTrgBlock";
import * as React from "react";
import DialogSetDefaultFeatMap from "../_subcomponents/DialogSetDefaultFeatMap";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";


export default function FeatureMap() {
    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)
    // const {state} = useLocation(); and then const {value, featObj} = state

    let {prjid, cat_pk, feat_pk, val_pk} = useParams()    // val_pk: 0 | uid | usemap

    const keyDataSet: any = {
        mapType: 'feature',
        projUID: String(prjid),
        catUID: cat_pk,
        featUID: feat_pk,
        valUID: val_pk
    }

    const navigate = useNavigate()

    // breadcrumbs variables
    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Features List', 'link': '../1'},
        {'name': 'Target feature map', 'link': ''}
    ]
    if (val_pk !== 'usemap' && val_pk !== '0') {
        crumbItems.splice(-1, 0, {'name': 'Values List', 'link': `../${cat_pk}/${feat_pk}/values/1`},)
    }

    // drag-n-drop variable
    const dragElem = useRef(undefined)

    // default mapping related variables
    const [featDefmapStatus, setFeatDefmapStatus] = useState('')
    const defMapURL: string = featDefmapStatus === 'isDefault' ? `../${cat_pk}/${feat_pk}/values/1` : ''

    const defmapRefObj = useRef<any>({})
    let defmapUsedURL: string = ''
    if (val_pk === '0') {
        defmapUsedURL = `../map/${defmapRefObj?.current?.defMapCatUID}/${defmapRefObj?.current?.defMapFeatUID}/0`
    } else {
        defmapUsedURL = `../${defmapRefObj?.current?.defMapCatUID}/${defmapRefObj?.current?.defMapFeatUID}/values/1`
    }

    const [defmapOpen, setDefmapOpen] = useState(false)
    //>

    const catMapLink = (val_pk === 'usemap' ?  `../../fields/map/${cat_pk}/usemap` : `../../fields/map/${cat_pk}`)

    const [hideMap, setHideMap] = useState<boolean>(false)
    const [dialogResult, setDialogResult] = useState<string>('')

    const [mapInfo, setMapInfo] = useState<any>({mapRemark: ''})

    const [srcCats, setSrcCats] = useState({})

    // target block variables
    const [trgCatFeatObj, setTrgCatFeatObj] = useState({
        catUID: '',
        catID: '',
        catName: '',
        featUID: '',
        featID: '',
        featName: '',
        featType: '',
        featStatus: '',
        featUnit: '',
        trgValName: '',
        trgValUID: ''
    })
    const [trgCatOptions, setTrgCatOptions] = useState([])

    // two variables below related to the case when usemap target combination already mapped
    const [usemapExists, setUsemapExists] = useState(false)
    const [usemapRedirectURL, setUsemapRedirectURL] = useState('')

    // save actions related variables
    const isMapSavedInDB = useRef<any>(false)
    const [saveStatus, setSaveStatus] = useState(0)

    const [feedsUpdateObj, setFeedsUpdateObj] = useState({
        feedID: 0,
        srcFeatsIDs: []
    })


    // mapping object variables
    const initialObjEmpty = {
        ID: 1,
        condition: 'and',
        rules: val_pk === 'usemap' ? [] : [{
            ID: 0,
            fieldType: 'feature',
            fieldName: '',
            fieldID: '',
            valueCondition: 'equal (=)',
            values: '',
            useAS: 'condition',
            returnTemplate: '',
            transformRules: ''
        }]
    }
    const [condObject, setCondObject] = useState<any>(initialObjEmpty)
    // console.log(condObject)
    const [returnObj, setReturnObj] = useState<any>({
        actionType: 'none',
        joinDelim: '',
        transformRules: '',
        returnType: 'default',
        returnIfCond: ''
    })
    //>



    // FUNCTIONS

    // getting "direct map" or "usemap" data
    useEffect(() => {
        if (val_pk === 'usemap') {
            getUsemapSrcData()
        } else {
            getFeatValMap()    // "classic" mapping
        }
    }, [])


    // gets data when the mapping is "direct (aka target)" (map)
    let getFeatValMap = async () => {
        let response = await fetch(`${serverIP}/getfeatvalmap/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(keyDataSet),
        })
        let data = await response.json()

        if (response.status === 200) {

            if (!('srcCats' in data)) {    // means the 'trg category' of a 'trg feature' is not mapped
                setHideMap(true)
            } else {

                setSrcCats(data.srcCats)    // srcCats: 'Notebooks (151); Database Software (4)'

                setTrgCatFeatObj(data.trgCatFeatData)    // 'trgCatFeat': {'cat_id': '30007661', 'cat_name': 'Laptop', 'feat_id': 'Storage Media'}

                setFeatDefmapStatus(data.featDefmapStatus)

                setMapInfo(data.mapInfo)    // comment, date of mapping, who mapped

                defmapRefObj.current = data.defmapRefObj

                // !important: mapObj = conObj + return Obj
                if (data.mapObj && data.mapObj.condObj?.rules?.length > 0) {
                    setCondObject(data.mapObj.condObj)
                    setReturnObj(data.mapObj.returnObj)
                    isMapSavedInDB.current = true
                }
            }

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    // gets data when the mapping is "reversed (aka source)" (usemap)
    let getUsemapSrcData = async () => {
        let response = await fetch(`${serverIP}/featusemapgetsrcdata/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(keyDataSet),
        })
        let data = await response.json()

        if (response.status === 200) {
            if (data.trgData?.length === 0) {
                setHideMap(true)
            } else {
                let sub: any = {[data.srcData.catID] : `${data.srcData.catName} (${data.srcData.catID})`}
                setSrcCats(sub)

                setCondObject({
                    ID: 0,
                    condition: 'and',
                    rules: [{
                        ID: 0,
                        fieldType: 'feature',
                        fieldName: `${data.srcData.features.featName} (${data.srcData.features.featID})`,
                        fieldID: `${data.srcData.features.featID}`,
                        valueCondition: 'equal (=)',
                        values: '',
                        useAS: '',
                        returnTemplate: '',
                        transformRules: ''
                    }]
                })

                setTrgCatOptions(data.trgData)
            }

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }


    let checkCondObj = (f_rules: any, is_valid: any) => {
        // was tested here:   https://onecompiler.com/javascript/43jh2bsxs
        for (let item of f_rules) {
            if ('rules' in item) {
                // console.log('this is a GROUP');
                is_valid = checkCondObj(item['rules'], is_valid);
            } else {
                if (
                    (!item['fieldType'] && !item['fieldName']) ||
                    (item['fieldType'] && !item['fieldName'])
                ) {
                    // console.log("NOT VALID")
                    is_valid = false
                }
            }
        }
        return is_valid
    }

    function handleSave(event: any) {

        if (!checkCondObj(condObject["rules"], true)) {
            // mapping object is NOT valid
            setSaveStatus(422)    // unprocessable content

        } else {

            let callDataObj = {
                ...keyDataSet,
                condObj: condObject,
                returnObj: returnObj,
                user: user.username,
                trgObj: trgCatFeatObj
            }

            fetch(`${serverIP}/featsavemap/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + String(authTokens.access)
                },
                body: JSON.stringify(callDataObj),
            }).then(res => res.json())
                .then((data) => {
                    setSaveStatus(data.status)
                    setMapInfo((prevState: any) => {
                        return {...prevState, mapStatus: 'mapped'}
                    })
                    setFeedsUpdateObj((prevState: any) => {
                        return {...prevState, feedID: data.feedID, srcFeatsIDs: data.srcFeatsIDs}
                    })
                    // console.log(data)
                })
        }
    }

    // updates products 'feeds' DB after mapping is saved
    let postSaveFeedsUpdate = async () => {
        let response = await fetch(`${serverIP}/aftersavemapfeedsupdate/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(feedsUpdateObj),
        })
        let data = await response.json()
        console.log(data)
        // if (response.status === 200) {
        // }
    }

    useEffect(()=> {
        if (saveStatus === 200) {   // should it also be saveStatus === 305 ??
            postSaveFeedsUpdate()
            setFeedsUpdateObj((prev: any) => {
                return {...prev, feedID: 0, srcFeatsIDs: []}
            })
        }
        }, [saveStatus]
    )


    let redirectAfterSaveUsemap = trgCatFeatObj?.trgValUID ?  `../map/${trgCatFeatObj.catUID}/${trgCatFeatObj.featUID}/${trgCatFeatObj.trgValUID}` :
        `../map/${trgCatFeatObj.catUID}/${trgCatFeatObj.featUID}/0`

    useEffect(() => {
        if (saveStatus > 0) {
            const timeId = setTimeout(() => {

                if (saveStatus !== 422) {
                    if (val_pk === 'usemap') {
                        navigate(redirectAfterSaveUsemap)
                    } else {
                        if (val_pk === '0') {    // redirect to Features List
                            navigate('../1', {state: {catID: trgCatFeatObj.catID, catName: trgCatFeatObj.catName}})
                        } else {    // redirect to Values List
                            navigate(`../${trgCatFeatObj.catUID}/${trgCatFeatObj.featUID}/values/1`)
                        }
                    }
                }
                setSaveStatus(0)
            }, 4000)

            return () => {
                clearTimeout(timeId)
            }
        }
    }, [saveStatus])

    useEffect(() => {
        if (dialogResult) {
            const timeId = setTimeout(() => {
                setDialogResult('')
            }, 4000)

            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dialogResult])

    const readOnlyModeAlertStyle = {
        backgroundColor: "#fff5e6",
        color: "#804d00",
        fontSize: "0.84rem"
    }

    return (
        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            {!userPermissions.canEdit && <Alert icon={false} style={readOnlyModeAlertStyle}>This is a "read only" mode. Changes cannot be saved. </Alert>}

            {saveStatus === 200 && <Alert severity="success">The mapping has been saved!</Alert>}
            {saveStatus === 304 && <Alert severity="info">The mapping has not been modified.</Alert>}
            {saveStatus === 305 && <Alert severity="info">The mapping is equal to the "default" one, so the "default" setting is applied.</Alert>}
            {saveStatus === 306 && <Alert severity="info">The mapping has been deleted.</Alert>}
            {dialogResult === 'defaultMapSet' && <Alert severity="info">This mapping has been set as "default".
                It will be applied for all same target features in all categories.</Alert>}

            {saveStatus === 422 && <Alert severity="error">NOT SAVED! The mapping object contains errors. Amend and try saving again.</Alert>}

            {featDefmapStatus === 'isDefMapUsed' && <Alert severity="info" style={{fontSize: '0.83rem'}}>
                A <b>"default" mapping</b> was applied. You can keep it "as is" or create a custom mapping.
                You can check or adjust the default feature's mappings <NavLink to={defmapUsedURL} reloadDocument={true} style={{textDecoration: 'underline'}} target="_blank">here</NavLink>.
                </Alert>}

            {featDefmapStatus === 'isDefault' && <Alert severity="success" style={{fontSize: '0.83rem'}}>
                This is a "default" mapping. It's applied to all "feature-value" pairs in all categories.&nbsp;
                {val_pk !== '0' ?
                    <>
                        You can unset the "default" status <NavLink to={defMapURL} reloadDocument={true} style={{textDecoration: 'underline'}} target="_blank">here</NavLink>.
                    </>
                    :
                    <>You can unset the "default" status on this page in the functions block.</>}
            </Alert>}

            {mapInfo.mapStatus === 'parked' && <Alert severity="warning">Mapping status is: {mapInfo.mapStatus}.
                If you want to create mapping, please, "unpark" it.</Alert>}

            {mapInfo.mapRemark && <Alert severity="info">Mapping comment: {mapInfo.mapRemark}</Alert>}

            {usemapExists && <Alert severity="warning">Selected target "category-feature-value" combination is already mapped.
                Please, click <NavLink to={usemapRedirectURL} reloadDocument={true}>here</NavLink> to proceed the mapping.</Alert>
            }

            {hideMap ?
                <Alert severity="error">Categories should be mapped first!
                    <br/> Please, proceed here: <NavLink to={catMapLink}>Map category</NavLink>
                </Alert>
                :
                <>
                    {val_pk === 'usemap' ?
                        <FeatUsemapTrgBlock
                            trgCatsOptions={trgCatOptions}
                            trgObj={trgCatFeatObj}
                            setTrgObj={setTrgCatFeatObj}
                            setUsemapExists={setUsemapExists}
                            projUID={prjid}
                            setUsemapRedirectURL={setUsemapRedirectURL}
                        />
                        :
                        <FeatMapTrgBlock trgCatFeatObj={trgCatFeatObj}/>
                    }

                    <div className="featmap-src-tools-container">
                        <div className="featmap-srccats">
                            <SourceCats srcCats={Object.values(srcCats).join('; ')}/>
                        </div>

                        <div className="featmap-tools">
                            <FeatmapTools
                                keyDataSet={keyDataSet}
                                setCondObject={setCondObject}
                                setReturnObj={setReturnObj}
                            />

                            {featDefmapStatus !== 'isDefMapUsed' && val_pk === '0' && isMapSavedInDB.current &&
                            <>
                                <DialogSetDefaultFeatMap
                                    open={defmapOpen}
                                    setOpen={setDefmapOpen}
                                    keyDataSet={{...keyDataSet, featID: trgCatFeatObj.featID, valName: trgCatFeatObj.trgValName}}
                                    setDialogResult={setDialogResult}
                                    featDefmapStatus={featDefmapStatus}
                                    setFeatDefmapStatus={setFeatDefmapStatus}
                                />
                                <LightTooltip title={featDefmapStatus === 'isDefault' ? "Cancel 'default' mapping status" : "Set as 'default' mapping"}>
                                    <CenterFocusStrongIcon
                                        color="action"
                                        className={userPermissions.canEdit ? "icon-clickable" : "icon-nonclickable"}
                                        style={featDefmapStatus === 'isDefault' ? {color: '#bf4040'} : {color: '#2e7d32'}}
                                        onClick={userPermissions.canEdit ? () => setDefmapOpen(true) : undefined}
                                    />
                                </LightTooltip>
                            </>}
                            <MapToolsBase
                                keyDataSet={keyDataSet}
                                mapInfo={mapInfo}
                                setMapInfo={setMapInfo}
                                setCondObject={setCondObject}
                                initialObjEmpty={initialObjEmpty}
                                featDefmapStatus={featDefmapStatus}
                                setSaveStatus={setSaveStatus}
                            />

                        </div>
                    </div>

                    {mapInfo.mapStatus !== 'parked' && (
                        <>
                            <ReturnBlock
                                returnObj={returnObj}
                                setReturnObj={setReturnObj}
                            />

                            <div className="top-group-container">
                                <QueryGroup
                                    condObject={condObject}
                                    setCondObject={setCondObject}
                                    currentGroup={condObject}
                                    level={1}
                                    currentRules={condObject.rules}
                                    index={0}
                                    // mapData={mapData}
                                    mapData={{...keyDataSet, srcCats: srcCats}}
                                    dragElem={dragElem}
                                />
                            </div>

                            {userPermissions.canEdit && <>
                                <div className="btn-save-container">
                                    <Button
                                        type={(condObject.rules?.length === 0 || usemapExists) ? "secondary" : "primary"}
                                        text="Save mapping"
                                        onclick={(event: any) => handleSave(event)}
                                        disabled={condObject.rules?.length === 0 || usemapExists}
                                    />
                                </div>
                            </>
                            }

                        </>)}
                </>
            }
        </>
    )
}
